// FIXME: 由於 Revenue breakdown 的翻譯是動態的，且只需要中文
import { Lang } from "@/i18n-config";

import { tranformSource } from "./tmp-transform-source";

// 暫時將翻譯放在這裡，之後和關鍵營運數據需要整合一個動態的翻譯系統
const tmpTranslation: Record<Lang, Record<string, Record<string, string>>> = {
  zh: {
    ...tranformSource(),
    shared: {
      Other: "其他",
    },
  },
  en: {
    AAPL: {},
  },
};

export const getRevenueBreakdownTranslation = (
  symbol: string,
  key: string,
  lang: Lang
) => {
  return (
    tmpTranslation[lang]?.[symbol]?.[key] ||
    tmpTranslation[lang]?.["shared"]?.[key] ||
    key
  );
};
